export default "__VITE_ASSET__8VyemLrf__"